export class UploadModel {
  public static IRI = '/api/uploads';
}
